import { FuncionActivo, TipoVehiculo } from 'modelos/src';

// Records completos: si se agrega un valor al enum en gestion-modelos no
// compila hasta sumarlo acá.
export const TIPO_VEHICULO_LABEL: Record<TipoVehiculo, string> = {
  Auto: 'Auto',
  Camion: 'Camión',
  Camioneta: 'Camioneta',
  Colectivo: 'Colectivo',
  Grua: 'Grúa',
  Moto: 'Moto',
  Otro: 'Otro',
};

export const FUNCION_ACTIVO_LABEL: Record<FuncionActivo, string> = {
  Ambulancia: 'Ambulancia',
  Bomberos: 'Bomberos',
  Mantenimiento: 'Mantenimiento',
  Particular: 'Particular',
  Policia: 'Policía',
  'Seguridad Privada': 'Seguridad Privada',
  'Servicio Técnico': 'Servicio Técnico',
  Transporte: 'Transporte',
  Otro: 'Otro',
};

/** Texto visible del tipo de vehículo; el valor del backend no lleva tildes. */
export function etiquetaTipoVehiculo(tipo?: string | null): string {
  if (!tipo) return '';
  return TIPO_VEHICULO_LABEL[tipo as TipoVehiculo] ?? tipo;
}

/** Texto visible de la función del activo. */
export function etiquetaFuncionActivo(funcion?: string | null): string {
  if (!funcion) return '';
  return FUNCION_ACTIVO_LABEL[funcion as FuncionActivo] ?? funcion;
}

/** "Camión / Bomberos", sin barra colgando cuando falta uno de los dos. */
export function etiquetaTipoYFuncion(
  tipo?: string | null,
  funcion?: string | null,
  separador = ' / ',
): string {
  return [etiquetaTipoVehiculo(tipo), etiquetaFuncionActivo(funcion)]
    .filter(Boolean)
    .join(separador);
}
